import angular from 'angular';
import { MeurhEscalaController } from './index/escala.index.controller';
import { MeurhEscalaNewController } from './new/escala.new.controller';
import { MeurhEscalaExcluirController } from './delete/escala.delete.controller';
import { MeurhEscalaConfigVisualizacaoModalController } from './modals/config-visualizacao/config-visualizacao.modal.controller';
import { MeurhEscalaConfigVisualizacaoModalService } from './modals/config-visualizacao/config-visualizacao.modal.service';
import { MeurhEscalaErrosImportacaoModalController } from './importacao/modals/erros/erros.modal.controller';
import { MeurhEscalaErrosImportacaoModalService } from './importacao/modals/erros/erros.modal.service';
import { MeurhEscalaSchedulerService } from './escala.scheduler.service';
import { MeurhEscalaSchedulerColaboradoresService } from './escala.scheduler.colaboradores.service';
import { MeurhEscalaListRouting } from './escala.routes';

import { MeurhEscalaImportacaoController } from './importacao/escala.importacao.controller';
import { MeurhEscalaImportacaoComponent } from './importacao/escala.importacao.component';

import { MeurhEscalaFiltrosController } from './filtros/escala.filtros.controller';
import { MeurhEscalaFiltrosComponent } from './filtros/escala.filtros.component';

import { MeurhEscalaColaboradoresFormController } from './form/colaboradores/colaboradores.form.controller';
import { MeurhEscalaColaboradoresFormComponent } from './form/colaboradores/colaboradores.form.component';
import { MeurhEscalaColaboradoresFormModalController } from './form/colaboradores/modal/colaboradores.modal.controller';
import { MeurhEscalaColaboradoresFormModalService } from './form/colaboradores/modal/colaboradores.modal.service';

import { MeurhEscalaDadosIniciaisFormController } from './form/dadosiniciais/dadosiniciais.form.controller';
import { MeurhEscalaDadosIniciaisFormComponent } from './form/dadosiniciais/dadosiniciais.form.component';

import { MeurhEscalaFolgaFormController } from './form/folga/folga.form.controller';
import { MeurhEscalaFolgaFormComponent } from './form/folga/folga.form.component';

import { MeurhEscalaLotacaoHorarioFormController } from './form/lotacaohorario/lotacaohorario.form.controller';
import { MeurhEscalaLotacaoHorarioFormComponent } from './form/lotacaohorario/lotacaohorario.form.component';

export const MeurhEscalaModule = angular.module('EscalaModule', ['ui.router.state', ])
    .controller('MeurhEscalaController', MeurhEscalaController)
    .controller('MeurhEscalaConfigVisualizacaoModalController', MeurhEscalaConfigVisualizacaoModalController)
    .controller('MeurhEscalaErrosImportacaoModalController', MeurhEscalaErrosImportacaoModalController)
    .controller('MeurhEscalaNewController', MeurhEscalaNewController)
    .controller('MeurhEscalaExcluirController', MeurhEscalaExcluirController)
    .controller('MeurhEscalaColaboradoresFormController', MeurhEscalaColaboradoresFormController)
    .controller('MeurhEscalaColaboradoresFormModalController', MeurhEscalaColaboradoresFormModalController)
    .controller('MeurhEscalaDadosIniciaisFormController', MeurhEscalaDadosIniciaisFormController)
    .controller('MeurhEscalaFolgaFormController', MeurhEscalaFolgaFormController)
    .controller('MeurhEscalaLotacaoHorarioFormController', MeurhEscalaLotacaoHorarioFormController)
    .controller('MeurhEscalaImportacaoController', MeurhEscalaImportacaoController)
    .controller('MeurhEscalaFiltrosController', MeurhEscalaFiltrosController)
    .component('meurhEscalaColaboradoresFormComponent', MeurhEscalaColaboradoresFormComponent)
    .component('meurhEscalaDadosIniciaisFormComponent', MeurhEscalaDadosIniciaisFormComponent)
    .component('meurhEscalaFolgaFormComponent', MeurhEscalaFolgaFormComponent)
    .component('meurhEscalaLotacaoHorarioFormComponent', MeurhEscalaLotacaoHorarioFormComponent)
    .component('meurhEscalaImportacaoComponent', MeurhEscalaImportacaoComponent)
    .component('meurhEscalaFiltrosComponent', MeurhEscalaFiltrosComponent)
    .service('MeurhEscalaConfigVisualizacaoModalService', MeurhEscalaConfigVisualizacaoModalService)
    .service('MeurhEscalaErrosImportacaoModalService', MeurhEscalaErrosImportacaoModalService)
    .service('MeurhEscalaColaboradoresFormModalService', MeurhEscalaColaboradoresFormModalService)
    .service('MeurhEscalaSchedulerService', MeurhEscalaSchedulerService)
    .service('MeurhEscalaSchedulerColaboradoresService', MeurhEscalaSchedulerColaboradoresService)
    .config(MeurhEscalaListRouting)
    .name;
